module.exports = __webpack_public_path__ + "static/media/NvphAluminet.11286c9c.webp";